export default class GeideaResponseUtil{
  private static map: Map<string, string> = new Map();

  public static respCodeWithErrorMsg(key: string): string | undefined {
    if (key.startsWith("9"))
      return "Declined, System Error";
    if (!this.map.has(key)) {
      this.map.set("100", "Declined");
      this.map.set("101", "Expired Card, Contact your bank");
      this.map.set("102", "Declined");
      this.map.set("103", "Declined");
      this.map.set("104", "Restricted card, transaction not allowed");
      this.map.set("105", "Declined");
      this.map.set("106", "PIN Tries Exceeded");
      this.map.set("107", "Declined");
      this.map.set("108", "Declined");
      this.map.set("109", "Declined");
      this.map.set("110", "Declined");
      this.map.set("111", "Declined, Contact your bank");
      this.map.set("112", "Declined");
      this.map.set("114", "Declined");
      this.map.set("115", "Transaction not allowed");
      this.map.set("116", "Not Enough Balance");
      this.map.set("117", "INVALID PIN");
      this.map.set("118", "Declined, Contact your bank");
      this.map.set("119", "Transaction not permitted to cardholder");
      this.map.set("120", "Declined");
      this.map.set("121", "Exceeds withdrawal amount limit");
      this.map.set("122", "Declined");
      this.map.set("123", "Declined, limits exceeded");
      this.map.set("125", "Declined, Contact your bank");
      this.map.set("126", "Declined");
      this.map.set("127", "Wrong PIN");
      this.map.set("128", "Declined");
      this.map.set("129", "Declined, Contact your bank");
      this.map.set("182", "Declined");
      this.map.set("183", "Declined");
      this.map.set("184", "Declined");
      this.map.set("185", "Declined");
      this.map.set("188", "Declined");
      this.map.set("190", "Declined");
      this.map.set("200", "Declined");
      this.map.set("201", "Expired Card, Contact your bank");
      this.map.set("202", "Declined");
      this.map.set("203", "Declined");
      this.map.set("204", "Transaction not allowed");
      this.map.set("205", "Declined");
      this.map.set("206", "PIN Tries Exceeded");
      this.map.set("207", "Declined");
      this.map.set("208", "Declined, Contact your bank");
      this.map.set("209", "Declined, Contact your bank");
      this.map.set("210", "Declined, Contact your bank");
      this.map.set("480", "Un successful");
      this.map.set("481", "Un successful");
      this.map.set("501", "RECONCILIATION UNSUCCESSFUL");
      this.map.set("888", "Error");
    }
    return this.map.get(key);
  }
}
